import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapGettersHeader } = createNamespacedHelpers('header')

export default {
  name: 'rb-header-dynamic-submenu-title',
  computed: {
    ...mapGettersHeader(['currentMenuId']),
  },
  render(createElement) {
    if (!this.$slots.default) return

    const filteredSlots = this.$slots.default?.filter((slot) => !!slot.tag)
    if (!filteredSlots) return

    const currentMenuIdSlot = filteredSlots.find((slot) => {
      if (!slot?.componentOptions?.propsData) return

      const slotMenuId = slot.componentOptions.propsData['menuId']
      return slotMenuId === this.currentMenuId
    })

    return createElement('div', [currentMenuIdSlot])
  },
}
